import { all, fork } from 'redux-saga/effects';

import listenLoad from './listenLoad';
import listenLoadFeaturedVehicles from './listenLoadFeaturedVehicles';

export default function* subscribeSaga() {
  yield all([fork(listenLoad), fork(listenLoadFeaturedVehicles)]);
}
